export default "__VITE_ASSET__14b4def1__"